import React from 'react';
import styel from './style.scss';
import Product from 'components/partials/product';
import {Categories} from 'api';

class SameProduct extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    if (this.props.categoryId) {
      const params = {
        id: this.props.categoryId,
        filter: {
          limit: 6,
          where: {
            id: {
              neq: this.props.productId
            }
          }
        }
      };
      params.filter = JSON.stringify(params.filter);
      Categories.actions.listFixProducts.request(params).then(response => {
        this.setState({data: response.data});
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.categoryId) {
      const params = {
        id: nextProps.categoryId,
        filter: {
          limit: 6,
          where: {
            id: {
              neq: nextProps.productId
            }
          }
        }
      };
      params.filter = JSON.stringify(params.filter);
      Categories.actions.listFixProducts.request(params).then(response => {
        this.setState({data: response.data});
      });
    }
  }

  render() {
    if (this.state.data.length === 0) {
      return null;
    }
    return (
      <section className="same-product">
        <h3 className='same-product-title'>Các sản phẩm tương tự</h3>
        <div className='wrap-same-product'>
          <div className='same-product-contailer'>
            {
              this.state.data.map((item, i) => {
                return (
                  <div className='product-wrap' key={i}>
                    <Product enableAddProduct={true} {...item}/>
                  </div>
                );
              })
            }
          </div>
        </div>
      </section>
    );
  }
}

export default SameProduct;



// WEBPACK FOOTER //
// ./components/partials/product/popup-view-detail/same-product/SameProduct.jsx